import {
    checkCode,
    toolsRegularCheckCode,
} from "@/api/service";


export function CheckCode(stCodeCheckInput) {
    let _resultStr = toolsRegularCheckCode(JSON.stringify(stCodeCheckInput));
    if (_resultStr != null && _resultStr.length > 0) {
        var _result = JSON.parse(_resultStr);
        return _result;
    } else {
        let responseStr = checkCode(JSON.stringify(stCodeCheckInput));
        if (responseStr != null && responseStr.length > 0) {
            var response = JSON.parse(responseStr);
            return response;
        }
    }

    return null;
}
